// TODO: Should be removed with the old planner
import moment from 'moment';

export const getTripDurationAsText = (start: Date, end: Date): string => {
  let durationText = '';

  const getPlural = (word: string, count: number): string => `${word}${count > 1 ? 's' : ''}`;

  const momentStart = moment(start);
  const momentEnd = moment(end);

  const duration = moment.duration(momentEnd.diff(momentStart));

  const days = Math.floor(duration.asDays());
  duration.subtract(moment.duration(days, 'days'));

  const hours = duration.hours();
  duration.subtract(moment.duration(hours, 'hours'));

  const minutes = duration.minutes();
  duration.subtract(moment.duration(minutes, 'minutes'));

  if (days) {
    durationText += `${days} ${getPlural('Day', days)} `;
  }

  if (hours) {
    durationText += `${hours} ${getPlural('Hour', hours)} `;
  }

  if (minutes) {
    durationText += `${minutes} ${getPlural('Minute', minutes)}`;
  }

  return durationText;
};
